export default {
  valor: {
    value: null,
    required: true,
    state: null
  },
  unidade: {
    value: null,
    required: false,
    maxlength: 10,
    state: null
  },
  codigoCliente: {
    value: null,
    required: false,
    maxlength: 50,
    state: null
  },
  descricaoCliente: {
    value: null,
    required: false,
    maxlength: 200,
    state: null
  },
  observacao: {
    value: null,
    required: false,
    maxlength: 1000,
    state: null
  },
  colunas: {
    value: [],
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/pci/lpu/addItemDetail-form.js